<template>
  <div class='container'>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-9 order-md-2">
        <VideoPlayer
          :src='channel.path'
          :auto-play='false'
          :title="channel.name"
          :genre="channel.title"
          :thumbnail='channel.logo'
          :is-live='true'
          :update-play-time='false'
          v-if="channel.path"
        />
        <span class="alert-warning" v-else>
          No live channel was founed please try again
        </span>
      </div>
      <div class="col-12 col-md-4 col-lg-3 order-md-1">
        <div class='btn-container'>
          <el-button
            type='primary'
            icon='el-icon-arrow-left'
            @click='() => $router.push({ name: "live.home.list", params: {category}})'
          >
            Back to categories
          </el-button>
        </div>
        <div class="catg-container">
          <h5>{{ $route.params.category }} Channels</h5>
          <el-menu
            default-active="/live/ALL" 
            class="el-menu-demo" 
            mode="vertical" 
            router
          >
            <perfect-scrollbar style='height: calc(100vh - 100px)' ref='playlistScroll2'>
              <el-menu-item 
                v-for='(channel, i) in channels'
                :key='i'
                :index='`/live/${category}/${channel.channel_id}`'
              >
                {{ channel.name }}
              </el-menu-item>
            </perfect-scrollbar>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authRequest } from '../../../app/helpers';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import VideoPlayer from '../../../components/VideoPlayer';

export default {
  components: {
    PerfectScrollbar,
    VideoPlayer,
  },
  data: () => ({
    channels: [],
    channel: {},
    loading: true,
    related: [],
  }),
  computed: {
    category() {
      return this.$route.params.category;
    }
  },
  watch: {
    $route() {
      this.getChannel();
    }
  },
  mounted() {
    this.fetchChannels();
    this.getChannel();
  },
  methods: {
    async fetchChannels() {
      this.loading = true;
      
      const res = await authRequest(
        this.$router, 
        '/channels?category=' + (this.$route.params.category).replace('ALL', '')
      );

      this.channels = res.data;
    },

    async getChannel() {
      this.loading = true;
      this.related = [];
      this.channel = {};

      const {id} = this.$route.params;
      const req = await authRequest(this.$router, '/channels/' + id );

      this.channel = req.channel;
      this.related = req.relatedChannels;
      this.loading = false;
    },
  }
}
</script>


<style lang="scss" scoped>
.catg-container {
    background: #1f1f1f;
}

ul.el-menu-demo.el-menu {
    background: transparent;
    border: none;
}

li.el-menu-item.is-active {
    background-color: #C70C13;
    color: white;
}

.catg-container h5 {
    color: #797979;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 20px 20px;
    margin-bottom: 0;
    background: #0e0e0e;
    border-bottom: 2px solid #010101;
}

.catg-container ::v-deep .ps__rail-y {
    z-index: 1;
}

li.el-menu-item {
    border-bottom: 1px solid #131212;
}
.btn-container {
  margin-bottom: 10px;
  button {
    width: 100%;
  }
}

</style>